import { DefendSphereAiPanel } from './DefendSphereAiPanel'
import { DefendSphereAiWorkspace } from './DefendSphereAiWorkspace'
import { useDefendSphereAi } from './DefendSphereAiProvider'

/** Renders panel/workspace overlays; must sit under DefendSphereAiProvider. */
export function DefendSphereAiShell() {
  const { enabled, mode } = useDefendSphereAi()
  if (!enabled) return null
  return (
    <>
      {mode === 'panel' ? <DefendSphereAiPanel /> : null}
      {mode === 'workspace' ? <DefendSphereAiWorkspace /> : null}
    </>
  )
}
